import { graphql, usePreloadedQuery } from 'react-relay';
import { useLabelsStore } from '@atlassian/jira-issue-table/src/services/field/colored-labels/index.tsx';
import type { coloredLabelsUpdater_getLabelsInBoardQuery } from '@atlassian/jira-relay/src/__generated__/coloredLabelsUpdater_getLabelsInBoardQuery.graphql';
import { coloredLabelsResource } from '@atlassian/jira-router-resources-colored-labels/src/services/index.tsx';
import { useRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';

export const ColoredLabelsUpdater = () => {
	const { queryReference } = useRelayResource(coloredLabelsResource);

	if (queryReference) {
		// eslint-disable-next-line react-hooks/react-compiler
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const [, { labelToColoredLabel }] = useLabelsStore();

		// eslint-disable-next-line react-hooks/react-compiler
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const result = usePreloadedQuery<coloredLabelsUpdater_getLabelsInBoardQuery>(
			graphql`
				query coloredLabelsUpdater_getLabelsInBoardQuery($boardId: ID!) {
					jira {
						labelsInBoard(boardId: $boardId) {
							edges {
								node {
									name
									color {
										colorKey
									}
								}
							}
						}
					}
				}
			`,
			queryReference,
		);

		if (result) {
			result.jira?.labelsInBoard?.edges?.forEach((labelsNode) => {
				const labelName = labelsNode?.node?.name;
				const labelColor = labelsNode?.node?.color;

				if (labelName) {
					labelToColoredLabel(labelName, labelColor?.colorKey);
				}
			});
		}
	}

	return null;
};
